import { ReactNode } from 'react'

import {
  BrandExposureGlyph,
  GolfAccessGlyph,
  GuestOpportunitiesGlyph,
  NetworkingEventsGlyph,
  NetworkingServiceGlyph,
  TeamWellbeingGlyph,
} from 'Assets/Svg/Section/EmajinCorporateMembershipPackages'

export type EmajinCorporateMembershipPackagesPointItem = {
  id: string
  icon: ReactNode
  text: string
}

export const EMAJIN_CORPORATE_MEMBERSHIP_PACKAGES_POINT_ITEM: EmajinCorporateMembershipPackagesPointItem[] =
  [
    {
      id: 'EmajinCorporateMembershipPackagesPointItem-001',
      icon: BrandExposureGlyph(),
      text: 'Enjoy unrivalled brand exposure among our high calibre members',
    },
    {
      id: 'EmajinCorporateMembershipPackagesPointItem-002',
      icon: GolfAccessGlyph(),
      text: 'Access Australia’s most exclusive golf courses and venues',
    },
    {
      id: 'EmajinCorporateMembershipPackagesPointItem-003',
      icon: TeamWellbeingGlyph(),
      text: 'Offer team building and wellbeing initiatives to reward your staff',
    },
    {
      id: 'EmajinCorporateMembershipPackagesPointItem-004',
      icon: NetworkingServiceGlyph(),
      text: 'Use our industry-leading networking service to build lasting business connections',
    },
    {
      id: 'EmajinCorporateMembershipPackagesPointItem-005',
      icon: NetworkingEventsGlyph(),
      text: 'Choose from 50+ exclusive networking events a year right across Australia',
    },
    {
      id: 'EmajinCorporateMembershipPackagesPointItem-006',
      icon: GuestOpportunitiesGlyph(),
      text: 'Take advantage of guest invitations and promotional opportunities',
    },
  ]
